<template>
  <section class="rf-skeleton d-print-none" :class="`rf-skeleton--${tipo}`"
    role="status" aria-live="polite" aria-busy="true">
    <span class="rf-skeleton-lectores">{{ mensaje }}</span>
    <div aria-hidden="true">
      <div v-if="tipo === 'barra'" class="rf-skeleton-barra">
        <v-skeleton-loader type="text" width="170" />
        <v-skeleton-loader class="rf-skeleton-boton" type="button" width="335" />
      </div>
      <div v-else-if="tipo === 'acciones'" class="rf-skeleton-acciones">
        <v-skeleton-loader v-for="n in 2" :key="n" class="rf-skeleton-boton"
          type="button" width="150" />
      </div>
      <template v-else-if="tipo === 'listado'">
        <div class="rf-skeleton-resumen">
          <v-skeleton-loader v-for="n in 3" :key="n" type="heading, text" />
        </div>
        <template v-if="$vuetify.breakpoint.xs">
          <v-skeleton-loader v-for="n in 3" :key="n" class="rf-skeleton-tarjeta"
            type="list-item-two-line, paragraph, actions" />
        </template>
        <v-skeleton-loader v-else type="table-thead, table-tbody" />
      </template>
      <template v-else>
        <div class="rf-skeleton-institucion">
          <v-skeleton-loader class="rf-skeleton-logo" type="image" width="145" height="70" />
          <v-skeleton-loader type="heading, text@2" />
        </div>
        <div class="rf-skeleton-titulo">
          <v-skeleton-loader type="heading" />
          <v-skeleton-loader type="text@2" width="140" />
        </div>
        <v-skeleton-loader type="text@3" />
        <div class="rf-skeleton-resumen">
          <v-skeleton-loader v-for="n in 3" :key="`dato-${n}`" type="text@2" />
        </div>
        <v-skeleton-loader class="rf-skeleton-seccion" type="heading" width="250" />
        <div class="rf-skeleton-avance">
          <v-skeleton-loader v-for="n in 2" :key="n" type="heading, text" />
        </div>
        <v-skeleton-loader class="rf-skeleton-seccion" type="heading" width="220" />
        <div class="rf-skeleton-resumen">
          <v-skeleton-loader v-for="n in 3" :key="`importe-${n}`" type="text@3" />
        </div>
        <div class="rf-skeleton-avance rf-skeleton-seccion">
          <v-skeleton-loader v-for="n in 2" :key="`comentario-${n}`" type="heading, paragraph" />
        </div>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SkeletonReporteFisico',
  props: {
    tipo: {
      type: String,
      default: 'documento',
      validator: (valor) => ['documento', 'listado', 'barra', 'acciones'].includes(valor),
    },
    mensaje: { type: String, default: 'Cargando información del reporte…' },
  },
};
</script>

<style scoped>
.rf-skeleton { width: 100%; }
.rf-skeleton--documento { max-width: 1100px; margin: 0 auto; padding: 40px; background: white; }
.rf-skeleton--barra { margin-bottom: 20px; }
.rf-skeleton-lectores {
  position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
  overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
}
.rf-skeleton-barra, .rf-skeleton-acciones { display: flex; align-items: center; gap: 12px; }
.rf-skeleton-barra { justify-content: space-between; }
.rf-skeleton-acciones { justify-content: flex-end; flex-wrap: wrap; }
.rf-skeleton-institucion {
  display: grid; grid-template-columns: 145px minmax(0, 1fr); gap: 28px; margin-bottom: 24px;
}
.rf-skeleton-titulo {
  display: grid; grid-template-columns: minmax(0, 1fr) 140px; gap: 24px; margin: 24px 0;
}
.rf-skeleton-resumen {
  display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 24px; margin: 16px 0;
}
.rf-skeleton-avance { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 24px; }
.rf-skeleton-seccion { margin-top: 28px; }
.rf-skeleton-tarjeta { margin-bottom: 16px; }
.rf-skeleton-boton ::v-deep .v-skeleton-loader__button { width: 100%; }
.rf-skeleton-logo ::v-deep .v-skeleton-loader__image { height: 70px; }
@media (max-width: 600px) {
  .rf-skeleton--documento { padding: 22px 18px; }
  .rf-skeleton-institucion, .rf-skeleton-titulo, .rf-skeleton-resumen {
    grid-template-columns: 1fr; gap: 16px;
  }
  .rf-skeleton-logo { margin: 0 auto; }
  .rf-skeleton-barra { flex-direction: column; align-items: stretch; }
  .rf-skeleton-barra .rf-skeleton-boton { width: 100% !important; }
  .rf-skeleton-avance { gap: 12px; }
}
@media (prefers-reduced-motion: reduce) {
  .rf-skeleton ::v-deep .v-skeleton-loader__bone::after { animation: none !important; }
}
</style>
